import React, { useState, useEffect } from 'react';
import axios from 'axios';
import RichTextEditor from './RichTextEditor';

const API_URL = `${process.env.REACT_APP_API_URL}/api`;

const fmtPrecio = (v) => v ? Number(v).toLocaleString('es-CL') : '';

function FormProducto({ onCancel, onSuccess, productoEditando, categorias = [] }) {
  const [form, setForm] = useState(() =>
    productoEditando
      ? {
          nombre:         productoEditando.nombre         || '',
          descripcion:    productoEditando.descripcion    || '',
          especificacion: productoEditando.especificacion || '',
          precio:         fmtPrecio(productoEditando.precio),
          stock:          productoEditando.stock          || '',
          categoria:      String(productoEditando.idCategoria || ''),
        }
      : { nombre: '', descripcion: '', especificacion: '', precio: '', stock: '', categoria: '' }
  );
  const [imagenNueva, setImagenNueva]   = useState(null);
  const [imagenActual, setImagenActual] = useState(null);

  // Rellenar form al editar
  useEffect(() => {
    if (productoEditando) {
      setForm({
        nombre:         productoEditando.nombre         || '',
        descripcion:    productoEditando.descripcion    || '',
        especificacion: productoEditando.especificacion || '',
        precio:         fmtPrecio(productoEditando.precio),
        stock:          productoEditando.stock          || '',
        categoria:      String(productoEditando.idCategoria || ''),
      });
      setImagenActual(productoEditando.imagen || null);
      setImagenNueva(null);
    } else {
      setForm({ nombre: '', descripcion: '', especificacion: '', precio: '', stock: '', categoria: '' });
      setImagenActual(null);
      setImagenNueva(null);
    }
  }, [productoEditando]);

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handlePrecioChange = (e) => {
    const soloDigitos = e.target.value.replace(/\D/g, '');
    setForm(prev => ({ ...prev, precio: soloDigitos ? Number(soloDigitos).toLocaleString('es-CL') : '' }));
  };

  const handleImagenChange = (e) => {
    const file = e.target.files[0];
    setImagenNueva(file || null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token   = localStorage.getItem('token');
      const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };

      const producto = {
        nombre:         form.nombre,
        descripcion:    form.descripcion,
        especificacion: form.especificacion,
        precio:         Number(String(form.precio).replace(/\./g, '')),
        stock:          Number(form.stock),
        categoria:      { id: Number(form.categoria) },
      };

      let id;
      if (productoEditando) {
        const res = await axios.put(`${API_URL}/productos/update/${productoEditando.id}`, producto, { headers });
        id = res.data.id;
      } else {
        const res = await axios.post(`${API_URL}/productos/insert`, producto, { headers });
        id = res.data.id;
      }

      // Solo sube imagen si el usuario seleccionó una nueva
      if (imagenNueva) {
        const formData = new FormData();
        formData.append('file', imagenNueva);
        await axios.post(`${API_URL}/productos/${id}/imagen`, formData, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      alert(productoEditando ? 'Producto actualizado' : 'Producto guardado');
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error(error);
      alert('Error al guardar producto');
    }
  };

  const previewSrc = imagenNueva
    ? URL.createObjectURL(imagenNueva)
    : imagenActual
      ? `${process.env.REACT_APP_API_URL}${imagenActual}`
      : null;

  return (
    <form onSubmit={handleSubmit} style={styles.form}>
      <h3 style={{ margin: '0 0 12px' }}>
        {productoEditando ? '✏️ Editar Producto' : '➕ Nuevo Producto'}
      </h3>

      <label>Nombre</label>
      <input name="nombre" value={form.nombre} onChange={handleChange} required style={styles.input} />

      <label>Descripción</label>
      <RichTextEditor
        value={form.descripcion}
        onChange={(html) => setForm(prev => ({ ...prev, descripcion: html }))}
      />

      <label>Especificación</label>
      <input name="especificacion" value={form.especificacion} onChange={handleChange} required style={styles.input} />

      <div style={styles.fila}>
        <div style={styles.campo}>
          <label>Precio</label>
          <input name="precio" type="text" inputMode="numeric" value={form.precio} onChange={handlePrecioChange} required style={styles.input} placeholder="0" />
        </div>
        <div style={styles.campo}>
          <label>Stock</label>
          <input name="stock" type="number" value={form.stock} onChange={handleChange} required style={styles.input} />
        </div>
      </div>

      <label>Categoría</label>
      <select name="categoria" value={form.categoria} onChange={handleChange} required style={styles.input}>
        <option value="">Seleccione una categoría</option>
        {categorias.map((cat) => (
          <option key={cat.id} value={String(cat.id)}>{cat.nombre}</option>
        ))}
      </select>

      <label>
        Imagen{productoEditando && <span style={{ color: '#888', fontWeight: 'normal' }}> — dejar vacío para mantener la actual</span>}
      </label>

      {previewSrc && (
        <div style={styles.previewContainer}>
          <img src={previewSrc} alt="Preview" style={styles.preview} />
          {imagenNueva && (
            <span style={styles.badgeNueva}>Nueva imagen</span>
          )}
        </div>
      )}

      <input
        type="file" name="imagen" accept="image/*"
        onChange={handleImagenChange}
        required={!productoEditando}
        style={{ marginTop: 4 }}
      />

      <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
        <button type="submit" style={styles.btnGuardar}>
          {productoEditando ? '💾 Actualizar' : '💾 Guardar'}
        </button>
        <button type="button" onClick={onCancel} style={styles.btnCancelar}>Cancelar</button>
      </div>
    </form>
  );
}

const styles = {
  form:   { display: 'flex', flexDirection: 'column', gap: 6, maxWidth: 520 },
  input:  { padding: '7px 10px', borderRadius: 4, border: '1px solid #ccc', width: '100%', boxSizing: 'border-box' },
  fila:   { display: 'flex', gap: 12 },
  campo:  { flex: 1, display: 'flex', flexDirection: 'column', gap: 4 },
  previewContainer: { position: 'relative', display: 'inline-block', marginTop: 4 },
  preview: { width: 120, height: 120, objectFit: 'cover', borderRadius: 6, border: '1px solid #ddd' },
  badgeNueva: {
    position: 'absolute', top: 4, left: 4, backgroundColor: '#16a34a',
    color: '#fff', fontSize: 10, padding: '2px 6px', borderRadius: 8
  },
  btnGuardar:  { padding: '8px 20px', backgroundColor: '#1a1a2e', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' },
  btnCancelar: { padding: '8px 20px', backgroundColor: '#e5e7eb', color: '#333', border: 'none', borderRadius: 6, cursor: 'pointer' },
};

export default FormProducto;
